export const GET_PAYMENT_METHODS = 'get-payment-methods';

export default function getPaymentMethods() {
  return {
    type: GET_PAYMENT_METHODS,
  };
}
